export default "__VITE_ASSET__BGlZ704q__"